import { render, staticRenderFns } from "./AIContentList.vue?vue&type=template&id=11beb896&scoped=true&"
import script from "./AIContentList.vue?vue&type=script&lang=js&"
export * from "./AIContentList.vue?vue&type=script&lang=js&"
import style0 from "./AIContentList.vue?vue&type=style&index=0&id=11beb896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11beb896",
  null
  
)

export default component.exports